<template>
  <div v-dompurify-html="html"></div>
</template>

<script>
// import {commonClickFn} from './componentArticle/commonModuleFn'
export default {
  name: "staticContent",
  props: {
    receiveProps:{
      type: [Object, Array],
      default: ()=>{}
    }
  },
  data() {
    return {
      html: ''
    }
  },
  mounted() {
    this.html = this.receiveProps.tempData.staticBlockCode
  },
  methods: {
    
  },
};
</script>

<style lang="less" scoped>

</style>